import "./Contributor.css";
import Stars from "../../stars rate/Stars";
import { FaFacebook } from "react-icons/fa6";
import { LiaWhatsapp } from "react-icons/lia";
import { BsTelegram, BsTwitter } from "react-icons/bs";
import { CiInstagram } from "react-icons/ci";
import { CiLinkedin } from "react-icons/ci";
import { useFetchData } from "../../../hooks/useFetchData";

function Contributor({staff,allRank,index}) {
  const platformIcons = {
    facebook: <FaFacebook />,
    whatsapp: <LiaWhatsapp />,
    telegram: <BsTelegram />,
    instagram: <CiInstagram />,
    twitter: <BsTwitter />,
    linkedin: <CiLinkedin />
  };
  
  

  const total = allRank?.salesByCategory?.reduce((acc, element) => acc + element.totalSales, 0);
  const classNames = ['cyan', 'pink', 'purple',''];
  function getRandomClass() {
    return classNames[Math.floor(Math.random() * classNames.length)];
  }
  const {data: comments} = useFetchData("mandoub/reviews?id="+(staff?._id ? staff?._id : staff?.mandoubDetails._id),[staff])
  console.log(staff,"================");
  
  
  
  return (
    <>
    {staff &&<div className="card">
      <img src= {staff.cover? process.env.REACT_APP_UPLOADS_DIR+staff.cover : "/img/banner.avif"}  className="banner" />

      <div className="ranked">
      الرتبة {index+1}
      </div>
     
      <div className="df-c g0">
        <div className="card-img-cont">
          <img src={staff.img? process.env.REACT_APP_UPLOADS_DIR+staff.img : "/img/default.png"} className="card-img" />
        </div>
        <div>
          <h2 className="name !mt-5"> {staff.fullName}</h2>
          {comments &&<div className="!text-sm text df mt-1" >
            <Stars number={Math.floor(comments.stats.averageRating)} /> <span className="text-xs">({comments.reviews.length})</span>
          </div>}
        </div>

      </div>
      <div className="desc " style={{ fontSize: '13px', fontWeight: 'bold', color: 'black' }}>
        حقق {staff.fullName} مبيعات قدرها {staff.weeklyContribution} كيلوجرام هذا الأسبوع.
      </div>

      
      {staff?.contact &&<div className="df jc-sa w-full media-list">
      {staff?.contact.map((contact, index) => (
              <div key={index} className="df-c g0 ai-center">
                <div className="bor">
                  <div className={`media-cont ${contact.platform}`}>
                    {platformIcons[contact.platform.toLowerCase()]}
                  </div>
                </div>
                <a href={contact.link} target="_blank" rel="noopener noreferrer">
                  <span className="text-xs">{contact.platform}</span>
                </a>
              </div>
            ))}
</div>}

      
    </div>}
     {allRank &&<div className="card">
      <img src= {allRank?.mandoubDetails.cover? process.env.REACT_APP_UPLOADS_DIR+allRank?.mandoubDetails.cover : "/img/banner.avif"}  className="banner" />
      <div className="ranked">
      الرتبة {index+1}
      </div>
      <div className="df-c g0">
        <div className="card-img-cont">
          <img src={allRank.mandoubDetails.img? process.env.REACT_APP_UPLOADS_DIR+allRank.mandoubDetails.img : "/img/default.png"} className="card-img" />
        </div>
        <div>
          <h2 className="name !mt-5"> {allRank.mandoubDetails.fullName}</h2>
          <div className="!text-sm text df mt-1" >
            <Stars number={4} /> <span className="text-xs">({allRank.mandoubDetails.reviews.length})</span>
          </div>
        </div>

      </div>
      <div className="desc" style={{ fontSize: '13px', fontWeight: 'bold', color: 'black' }}>
  لقد حقق  {allRank.mandoubDetails.fullName} مبيعات بلغت {allRank.mandoubDetails.weeklyContribution} كيلوجرام هذا الأسبوع، و {total} كإجمالي المبيعات.
</div>
      <div className="actions">
  {allRank?.salesByCategory && allRank?.salesByCategory.map((sale) => {
    const percentage = (sale.totalSales / total) * 100;
    const randomClass = getRandomClass();

    return (
      <div className="df" key={sale.category._id}>
        <span>{sale.category.name}</span>
        <div className={`progress-container ${randomClass}`}>
          <div className={`progress-bar ${randomClass}`} style={{ width: `${percentage.toFixed(2)}%` }}>
            <div className="progress-label">{percentage.toFixed(2)}%</div>
          </div>
        </div>
      </div>
    );
  })}
</div>
      
      
{allRank?.mandoubDetails?.contact &&<div className="df jc-sa w-full media-list">
      {allRank?.mandoubDetails?.contact.map((contact, index) => (
              <div key={index} className="df-c g0 ai-center">
                <div className="bor">
                  <div className={`media-cont ${contact.platform}`}>
                    {platformIcons[contact.platform.toLowerCase()]}
                  </div>
                </div>
                <a href={contact.link} target="_blank" rel="noopener noreferrer">
                  <span className="text-xs">{contact.platform}</span>
                </a>
              </div>
            ))}
</div>}

      
    </div>} 
    </>
  );
}

export default Contributor;
